import { gql } from '@apollo/client';

export const SEARCH_LOCATION_SUGGESTIONS_QUERY = gql`
  query LocationSuggestions($keyword: String) {
    locationSuggestions(keyword: $keyword) {
      items {
        id
        type
        title
        slug
        parentalMetroStation
      }
    }
  }
`;
